module.exports = __webpack_public_path__ + "media/pricing/Individual-f51a3c3d.png";